import InfoIcon from './InfoIcon.jsx';
import './RuleCard.css';

const CATEGORY_LABELS = {
  devices:    'Devices',
  dress:      'Dress',
  attendance: 'Attendance',
  integrity:  'Integrity',
  conduct:    'Conduct',
  safety:     'Safety',
};

export default function RuleCard({ rule }) {
  const effectiveSource = rule.verificationNeeded
    ? { ...rule.source, verificationNeeded: true, note: rule.verificationNote || rule.source?.note }
    : rule.source;

  const hasDetails =
    rule.consequences ||
    (rule.exceptions && rule.exceptions.length > 0) ||
    (rule.reportingOptions && rule.reportingOptions.length > 0);

  return (
    <article className={`rule-card rule-card--${rule.severity}`}>
      <div className="rule-card-header">
        <div className="rule-card-title-row">
          <h3 className="rule-card-title">
            {rule.shortTitle || rule.title}
          </h3>
          <span
            className={`rule-card-dot rule-card-dot--${rule.severity}`}
            aria-label={`${rule.severity} severity`}
            title={`Severity: ${rule.severity}`}
          />
        </div>
        <InfoIcon source={effectiveSource} />
      </div>

      <span className="rule-card-category">
        {CATEGORY_LABELS[rule.category] || rule.category}
      </span>

      <p className="rule-card-description">{rule.description}</p>

      {hasDetails && (
        <details className="rule-card-details">
          <summary>Consequences &amp; exceptions</summary>
          <div className="rule-card-details-body">
            {rule.consequences && (
              <div className="rule-card-detail-section">
                <p className="rule-card-detail-heading">Consequences</p>
                <p className="rule-card-detail-text">{rule.consequences}</p>
              </div>
            )}

            {rule.exceptions && rule.exceptions.length > 0 && (
              <div className="rule-card-detail-section">
                <p className="rule-card-detail-heading">Exceptions</p>
                <ul className="rule-card-list">
                  {rule.exceptions.map((e, i) => (
                    <li key={i}>{e}</li>
                  ))}
                </ul>
              </div>
            )}

            {rule.reportingOptions && rule.reportingOptions.length > 0 && (
              <div className="rule-card-detail-section">
                <p className="rule-card-detail-heading">How to report</p>
                <ul className="rule-card-list">
                  {rule.reportingOptions.map((r, i) => (
                    <li key={i}>{r}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </details>
      )}
    </article>
  );
}
